let React = require('react');

let GenericSelect = React.createClass({
    render: function () {
        return (<select id={this.props.id}
            className={this.props.class}
            onChange={this.props.onChange}
            value={this.props.value} >
            {this.props.options}
        </select>);
    }
});

export default GenericSelect